
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Pagination from '../pagination/Pagination'
import { Form, Link } from 'react-router-dom'
import {Spinner, ProgressBar } from "react-bootstrap";
import moment from 'moment'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { Container } from '@mui/system'
import { FaSearch } from 'react-icons/fa';
import { MDBBtn, MDBCollapse, MDBContainer, MDBFile, MDBValidation, MDBValidationItem } from 'mdb-react-ui-kit'
import Swal from 'sweetalert2';
import './index.css'



const ClubMember = () => {


  const [isUploading, setIsUploading] = useState(false);
const [uploadMessage, setUploadMessage] = useState("");
const [showDirectoryModal, setShowDirectoryModal] = useState(false);
const [directoryFile, setDirectoryFile] = useState(null);



  const [member, setMember] = useState([])
  const [showPerPage] = useState(20)
  const [pagination, setPagination] = useState(
    {
      start: 0,
      end: showPerPage
    }
  )

  const onChangePagination = (start, end) => {
    setPagination({ start: start, end: end })
  }

  const userId = sessionStorage.getItem("userId"); // Ensure this is stored at login
  const userType = sessionStorage.getItem("usertype");



  const [filteredMembers, setFilteredMembers] = useState([]);


  useEffect(() => {
  if (isUploading) {
    const messages = [
      "Reading PDF...",
      "Extracting member details...",
      "Processing pages...",
      "Saving member Data..."
    ];

    let i = 0;
    const interval = setInterval(() => {
      setUploadMessage(messages[i % messages.length]);
      i++;
    }, 4000);

    return () => clearInterval(interval);
  }
}, [isUploading]);


const openDirectoryModal = () => {
  setShowDirectoryModal(true);
};

const closeDirectoryModal = () => {
  if (!isUploading) {
    setShowDirectoryModal(false);
  }
};


// const memberData = async () => {
//   const dist = sessionStorage.getItem("dist");

//   const res = await axios.post(`https://lionsdirectoryapi.emedha.in/member/api/memberMasteData`, {
//     dist
//   });

//   setMember(res.data);
//   setFilteredMembers(res.data);
//   console.log(res.data);
// };

const memberData = async () => {
  try {
    const dist = sessionStorage.getItem("dist");
    const loggedInClubName = sessionStorage.getItem("clubName");
    const role = sessionStorage.getItem("role");

    console.log("=== RUNNING STRICT CLUB ALIGNMENT FILTERS ===");
    console.log("Looking strictly for club members of:", loggedInClubName);

    const res = await axios.post(`https://lionsdirectoryapi.emedha.in/member/api/memberMasteData`, {
      dist
    });

    if (role === "clubAdmin" && loggedInClubName) {
      const targetClubClean = loggedInClubName.trim().toLowerCase();

      const clubOnlyMembers = res.data.filter((member) => {
        const rawMemberClub = member.clubs || member.Clubs || "";
        
        if (!rawMemberClub) return false;

        const currentMemberClubClean = rawMemberClub.toString().trim().toLowerCase();

        // ✅ FIXED: Changed to an absolute exact string match only.
        // This stops "Suryapet Spandhana", "Suryapet Elite", etc., from leaking into "SURYAPET".
        return currentMemberClubClean === targetClubClean;
      });

      console.log(`=== STRICT MATCH COMPLETE ===`);
      console.log("Total Database District Rows:", res.data.length);
      console.log(`Total Strict Matched Members for [${loggedInClubName}]:`, clubOnlyMembers.length);

      setMember(clubOnlyMembers);
      setFilteredMembers(clubOnlyMembers);
      
    } else {
      // Fallback for Super Admin or District Admin
      setMember(res.data);
      setFilteredMembers(res.data);
      console.log("Loaded all district records without filtering. Total:", res.data.length);
    }
  } catch (error) {
    console.error("Error fetching or parsing member records context:", error);
  }
};

  const [memberClubName, setMemberClubName] = useState([])

// const memberDataClubName = async () => {
//   const dist = sessionStorage.getItem("dist"); // ✅ Get dist from session

//   const res = await axios.get(`https://lionsdirectoryapi.emedha.in/club/api/clubData`, {
//     params: { dist } // ✅ Pass dist as query param
//   });

//   setMemberClubName(res.data);
// };


const memberDataClubName = async () => {
  try {
    const dist = sessionStorage.getItem("dist");
    const loggedInClubName = sessionStorage.getItem("clubName");
    const loggedInClubNumber = sessionStorage.getItem("clubNumber");
    const role = sessionStorage.getItem("role");

    const res = await axios.get(`https://lionsdirectoryapi.emedha.in/club/api/clubData`, {
      params: { dist }
    });

    if (role === "clubAdmin" && loggedInClubName) {
      const targetClubClean = loggedInClubName.trim().toLowerCase();
      const targetClubNo = loggedInClubNumber ? loggedInClubNumber.toString().trim() : "";

      // Filter out the array list to hold ONLY this club's object profile row
      const matchedClubArray = res.data.filter((club) => {
        const currentClubNameClean = club.clubName ? club.clubName.trim().toLowerCase() : "";
        const currentClubNo = club.clubNumber ? club.clubNumber.toString().trim() : "";

        return currentClubNameClean === targetClubClean || (targetClubNo !== "" && currentClubNo === targetClubNo);
      });

      setMemberClubName(matchedClubArray);

      // ✅ Auto-Select & lock down: Instantly populate the form state variable with their profile name
      if (matchedClubArray.length > 0) {
        setClubName(matchedClubArray[0].clubName);
        console.log("Club Admin Auto-Selected Form Target:", matchedClubArray[0].clubName);
      }

    } else {
      // Keep normal layout flow functionality active for District / Super Admins
      setMemberClubName(res.data);
    }
  } catch (error) {
    console.error("Error running club metadata sync routine:", error);
  }
};

  useEffect(() => {
    memberData()
    memberDataClubName()
  }, [])

  const [number, setMemberNumber] = useState('')
  const [memberName, setMemberName] = useState('')
  const [clubName, setClubName] = useState('')
  const [designation, setDesignation] = useState('')
  const [profession, setProfession] = useState('')
  const [photo, setPhoto] = useState('')
  const [birth, setBirth] = useState('')
  const [marriage, setMarriage] = useState('')
  const [blood, setBlood] = useState('')
  const [address, setAddress] = useState('')
  const [mobile, setMobile] = useState('')
  const [email, setEmail] = useState('')
  const [spouseName, setSpouse] = useState('')
  const [myMessage, setMessage] = useState('')
  const [search, setSearch] = useState()


  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseBulk=()=>setIsOpen1(false)



//   const submitData = (e) => {
//     e.preventDefault();

//     // Create a new FormData instance
//     const formData = new FormData();
    
//     // Append all form fields to FormData
//     formData.append('number', number);
//     formData.append('memberName', memberName);
//     formData.append('clubName', clubName);
//     formData.append('designation', designation);
//     formData.append('profession', profession);
//     formData.append('birth', birth);
//     formData.append('marriage', marriage);
//     formData.append('blood', blood);
//     formData.append('address', address);
//     formData.append('mobile', mobile);
//     formData.append('email', email);
//     formData.append('spouseName', spouseName);
    
//     // Append the file if it exists
//     if (photo) {
//         formData.append('photo', photo);
//     }

//     // Send the request
//     axios.post('https://lionsdirectoryapi.emedha.in/member/api/memberCreate', formData, {
//         headers: {
//             'Content-Type': 'multipart/form-data'
//         }
//     })
//     .then(() => {
//         alert('Data Successfully Inserted!');
//         setShow(false);
//         setTimeout(() => memberData(), 100);
//     })
//     .catch((err) => alert('Error: ' + err.response.data));
// }

const submitData = (e) => {
  e.preventDefault();

  const dist = sessionStorage.getItem("dist"); // ✅ Get dist

  const formData = new FormData();
  formData.append('number', number);
  formData.append('memberName', memberName);
  formData.append('clubName', clubName);
  formData.append('designation', designation);
  formData.append('profession', profession);
  formData.append('birth', birth);
  formData.append('marriage', marriage);
  formData.append('blood', blood);
  formData.append('address', address);
  formData.append('mobile', mobile);
  formData.append('email', email);
  formData.append('spouseName', spouseName);
  formData.append('dist', dist); // ✅ Add dist

  if (photo) {
    formData.append('photo', photo);
  }

  axios.post('https://lionsdirectoryapi.emedha.in/member/api/memberCreate', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  .then(() => {
    alert('Data Successfully Inserted!');
    setShow(false);
    setTimeout(() => memberData(), 100);
  })
  .catch((err) => alert('Error: ' + err.response.data));
};




const deleteData = (id) => {
  const dist = sessionStorage.getItem("dist"); // ✅ Get dist

  if (window.confirm('Are you sure to delete this data...')) {
    axios.delete(`https://lionsdirectoryapi.emedha.in/member/api/deleteMember/${id}?dist=${dist}`)
      .then(() => {
        alert('Data deleted successfully!...');
        setTimeout(() => memberData(), 100);
      })
      .catch(err => alert("Error deleting data"));
  }
};

const searchHandler = (e) => {
  const dist = sessionStorage.getItem("dist"); // ✅ Get district value
  const searchValue = e.target.value;

  setSearch(searchValue);

  axios.post('https://lionsdirectoryapi.emedha.in/member/api/search', {
    search: searchValue,
    dist: dist
  }).then((resp) => {
    setFilteredMembers(resp.data);
  }).catch((err) => {
    console.error("Search error:", err);
  });
};

  


  const [isOpen1, setIsOpen1] = React.useState(false);
  const toggleOpen1 = () => setIsOpen1(!isOpen1);
  const [bfile, setBfile] = useState(null);


    const handleFileChange = (e) => {
      console.log('Selected File:', e.target.files[0]);
      setBfile(e.target.files[0]);
    };
    


//   const bulkuploadhandle = async (e) => {
//     e.preventDefault(); // Prevent default form submission

//     if (!bfile) {
//       Swal.fire({
//         icon: 'error',
//         title: 'File Required',
//         text: 'Please select a file to upload.',
//       });
//       return;
//     }

//     try {
//       const formData = new FormData();
//       formData.append('excel', bfile);

//       const response = await axios.post('https://lionsdirectoryapi.emedha.in/member/api/addmemberbulk', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       })
//       if (response.data.status === 200) {
//         toggleOpen1();
//         Swal.fire({
//           icon: 'success',
//           title: 'Success',
//           text: 'Data submitted successfully!',
//           customClass: {
//             confirmButton: 'custom-swal-button',
//           }
//         }).then(() => {
// alert('submitted successfully')
//         });
//       } else {
//         Swal.fire({
//           icon: 'error',
//           title: 'Oops...',
//           text: 'Something went wrong!',
//         });
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       Swal.fire({
//         icon: 'error',
//         title: 'Oops...',
//         text: 'Something went wrong!',
//       });
//     }
//   };


const bulkuploadhandle = async (e) => {
    const dist = sessionStorage.getItem("dist");
  e.preventDefault();

  if (!bfile) {
    Swal.fire({
      icon: 'error',
      title: 'File Required',
      text: 'Please select a file to upload.',
    });
    return;
  }

  try {
    const formData = new FormData();
    formData.append('excel', bfile);
    formData.append('dist', dist); // ✅ Append dist here

    const response = await axios.post('https://lionsdirectoryapi.emedha.in/member/api/addmemberbulk', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data.status === 200) {
      toggleOpen1();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Data submitted successfully!',
        customClass: {
          confirmButton: 'custom-swal-button',
        },
      }).then(() => {
        alert('submitted successfully');
            memberData()
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      });
    }
  } catch (error) {
    console.error('Error:', error);
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Something went wrong!',
    });
  }
};

const handleDirectoryUpload = async (e) => {
  e.preventDefault();

  if (!directoryFile) return;
  

  // Check file size (50 MB = 50 * 1024 * 1024 bytes)
  const MAX_SIZE = 50 * 1024 * 1024;
  if (directoryFile.size > MAX_SIZE) {
    alert("❌ PDF file size exceeds 50 MB. Please select a smaller file.");
    return;
  }

  setIsUploading(true);
  setUploadMessage("Reading PDF and extracting members... Please wait.");

  const formData = new FormData();
  formData.append("pdf", directoryFile);
  formData.append("dist", "320G");

  try {
    const res = await axios.post(
      "https://cloudapi.emedhatechnologies.com/members/api/uploadPdfAI",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    setUploadMessage(`✅ Successfully extracted ${res.data.totalExtracted} members.`);

    setTimeout(() => {
      setIsUploading(false);
      setShowDirectoryModal(false);
      window.location.reload();
    }, 2000);

  } catch (err) {
    setUploadMessage("❌ Upload failed. Please try again.");
    setIsUploading(false);
  }
};




  

  return (

    <>
      <Container><h5 className='text-center text-danger'>{myMessage}</h5></Container>
   <Button variant="primary" onClick={handleShow}>
        Add<PersonAddAltIcon></PersonAddAltIcon>
      </Button>
 {/* <Button rounded className='mx-3' color='secondary'  onClick={toggleOpen1}>
        Bulk upload
      </Button>
  <Button
  className="mx-3"
  color='info'

  onClick={openDirectoryModal}
>
  Upload Directory PDF
</Button>


      <Button rounded color='info' onClick={() => window.open('/sample_member_upload.xlsx', '_blank')}>
  Download Sample
</Button> */}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <br /><br /><br /><br /><br />
          <Modal.Title>Add</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={submitData}>
            <input type='number' className='form-control' placeholder='Membership Number' required onChange={(e) => setMemberNumber(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Membership Name' required onChange={(e) => setMemberName(e.target.value)} />
            <br />
            {/* <select type='text' className='form-control' placeholder='Designation' onChange={(e) => setClubName(e.target.value)}>
              <option>Select Club Name</option>
              {
                memberClubName.map((data) => {
                  return (
                    <option value={data.clubName}>
                      {data.clubName}
                    </option>
                  )
                })
              }
            </select> */}

            <select 
  className='form-control' 
  value={sessionStorage.getItem("role") === "clubAdmin" ? sessionStorage.getItem("clubName") : undefined}
  disabled={sessionStorage.getItem("role") === "clubAdmin"} 
  onChange={(e) => setClubName(e.target.value)}
>
  {sessionStorage.getItem("role") !== "clubAdmin" && <option value="">Select Club Name</option>}
  {
    memberClubName.map((data, index) => {
      return (
        <option key={index} value={data.clubName}>
          {data.clubName}
        </option>
      );
    })
  }
</select>
            <br />
            <input type='text' className='form-control' placeholder='Designation' required onChange={(e) => setDesignation(e.target.value)} />
            <br />

            <input type='text' className='form-control' placeholder='Mobile' onChange={(e) => setMobile(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Email' onChange={(e) => setEmail(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Spouse' onChange={(e) => setSpouse(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Profession' onChange={(e) => setProfession(e.target.value)} />
            <br />
            <input type='file' className='form-control' placeholder='choose file...' onChange={(e) => setPhoto(e.target.files[0])} />

            <br />
            <input type='date' className='form-control' placeholder='Birth Anniversary' onChange={(e) => setBirth(e.target.value)} />
            <br />
            <input type='date' className='form-control' placeholder='Marriage Anniversary' onChange={(e) => setMarriage(e.target.value)} />
            <br />

            <input type='text' className='form-control' placeholder='Blood Group' onChange={(e) => setBlood(e.target.value)} />
            <br />
            <input type='text' className='form-control' placeholder='Address' onChange={(e) => setAddress(e.target.value)} />
            <br />
            <button type='submit' className='btn btn-danger form-control'>Submit</button>
            <br />
            <br />
            <button type='reset' className='btn btn-secondary form-control'>Reset</button>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <FaSearch className='searchIcon'></FaSearch><input type='search' className='ms-4 search-input-field' placeholder='Search..' onChange={searchHandler} />

  
  <Modal show={isOpen1} onHide={handleCloseBulk} size='md'>
      <Modal.Header closeButton>
        <br /><br /><br /><br /><br />
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={bulkuploadhandle}>
          <label htmlFor='fileFrom'>Choose excel file to upload bulk data</label>
          <input type="file" id='fileFrom' onChange={handleFileChange} />

          <div className='col-12'>
            <Button type='submit' style={{ marginBottom: 30 }}>Upload</Button>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseBulk}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
       
<Modal
  show={showDirectoryModal}
  onHide={closeDirectoryModal}
  backdrop="static"
  keyboard={!isUploading}
>
  <Modal.Header closeButton={!isUploading}>
    <Modal.Title>Upload Directory PDF</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <form onSubmit={handleDirectoryUpload}>

      <input
        type="file"
        accept="application/pdf"
        disabled={isUploading}
        onChange={(e) => setDirectoryFile(e.target.files[0])}
        className="form-control"
        required
      />

      <br />

      <Button
        type="submit"
        variant="primary"
        disabled={isUploading}
        className="w-100"
      >
        {isUploading ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            Uploading Directory...
          </>
        ) : (
          "Upload"
        )}
      </Button>
    </form>

    {isUploading && (
      <div className="text-center mt-4">
        <p className="text-muted">{uploadMessage}</p>
        <ProgressBar animated now={100} />
      </div>
    )}
  </Modal.Body>
</Modal>


     
      <div style={{ marginTop: '1rem' }} className='table-container'>
        <table className="styled-table table  table-striped table-responsive table-bordered" >
          <thead>
            <tr>
              <th>S.No</th>
              <th>Membership_Number</th>
              <th>Membership_Name</th>
              <th>Club_Name</th>
              <th>Profile</th>
              <th>Designation</th>
              <th>Profession</th>
              <th style={{ width: '120px' }}>Date of birth</th>
              <th>Marriage_Anniversary</th>
              <th>Blood_Group</th>
              <th>Address</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Spouse</th>
           <th>Update</th>
            <th>Delete</th>
            </tr>
          </thead>
          <tbody className='table-bordered'>
            {
              filteredMembers.slice(pagination.start, pagination.end).map((data, index) => {

                let birth = ''
                let marriage = ''

                if (!moment(data.birthAnniversary).year()) {
                  birth = ''
                } else {
                  birth = `${moment(data.birthAnniversary).date()}/${moment(data.birthAnniversary).month() + 1}/${moment(data.birthAnniversary).year()}`
                }

                if (!moment(data.marriageAnniversary).year()) {
                  marriage = ''
                } else {
                  marriage = `${moment(data.marriageAnniversary).date()}/${moment(data.marriageAnniversary).month() + 1}/${moment(data.marriageAnniversary).year()}`
                }

                return (
                  <tr>
                     <td>{pagination.start + index + 1}</td>
                    <td>{data.membershipNo}</td>
                    <td>{data.membershipName}</td>
                    <td>{data.clubs}</td>
                    <td>
  <img src={`${data.photo}`} height='80px' width='80px' />
</td>

                    <td>{data.designation}</td>
                    <td>{data.profession}</td>
                    <td style={{ width: '120px' }}>{data.birthAnniversary}</td>
                    <td>{data.marriageAnniversary}</td>
                    <td>{data.bloodGroup}</td>
                    <td>{data.address}</td>
                    <td>{data.mobile}</td>
                    <td>{data.email}</td>
                    <td>{data.spouseName}</td>
              <td className=''>
                      <Link to={`/update/${data.memberId}`} className='btn btn-info text-white'>update</Link>
                    </td>
           <td className=''>
                      <Link to='#' className='btn btn-danger' onClick={() => deleteData(data.membershipNo)}>delete</Link>
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
        <Pagination page={showPerPage} onChangePagination={onChangePagination} total={member.length} />
      </div>


    </>
  )
}

export default ClubMember